import PropTypes from 'prop-types';
import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import OverlayLoader from '../../components/overloay-loader';
import { isModalDisplayed } from '../../selectors/modal-selectors';
import { getIsModalLoaded } from '../../selectors/is-loaded-selectors';
import transition from './modal-loader-transition.scss';

const ANIMATION_TIMEOUT = 600;

const ModalLoader = ({ isModalDisplayed, isModalLoaded }) => (
  <CSSTransitionGroup transitionName={transition} transitionEnterTimeout={ANIMATION_TIMEOUT} transitionLeave={false}>
    {isModalDisplayed && !isModalLoaded ? <OverlayLoader /> : null}
  </CSSTransitionGroup>
);

ModalLoader.propTypes = {
  isModalDisplayed: PropTypes.bool,
  isModalLoaded: PropTypes.bool,
};

const mapStateToProps = state => ({
  isModalDisplayed: isModalDisplayed(state),
  isModalLoaded: getIsModalLoaded(state),
});
export default connect(mapStateToProps)(ModalLoader);
